// ======================================================================
// File Name       : ModalIds
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const PROMT = 'PROMT';

export const COURSE_SORT = 'COURSE_SORT';
export const COURSE_DETAIL = 'COURSE_DETAIL';
export const COURSE_CONFIRM = 'COURSE_CONFIRM';
export const COURSE_EDIT_USER = 'COURSE_EDIT_USER';
export const COURSE_REGISTER_EDIT = 'COURSE_REGISTER_EDIT';
export const COURSE_EDIT_GROUP = 'COURSE_EDIT_GROUP';
export const CONTENT_LINKING_DETAIL = 'CONTENT_LINKING_DETAIL';
export const CONTENT_LINKING_CONFIRM = 'CONTENT_LINKING_CONFIRM';
export const CONTENT_LINKING_REGISTER = 'CONTENT_LINKING_REGISTER';
export const CONTENT_LINKING_REGISTER_EDIT_DETAIL_SETTING =
  'CONTENT_LINKING_REGISTER_EDIT_DETAIL_SETTING';

export const BOX_DETAIL = 'BOX_DETAIL';
export const BOX_REGISTER_EDIT = 'BOX_REGISTER_EDIT';
export const BOX_CONFIRM = 'BOX_CONFIRM';

// enterprise
export const ENTERPRISE_DETAIL = 'ENTERPRISE_DETAIL';
export const ENTERPRISE_EDIT = 'ENTERPRISE_EDIT';
export const ENTERPRISE_REGISTER = 'ENTERPRISE_REGISTER';
export const ENTERPRISE_DELETE = 'ENTERPRISE_DELETE';
export const ENTERPRISE_CONFIRM = 'ENTERPRISE_CONFIRM';
export const ENTERPRISE_NOTICE_CONFIRM = 'ENTERPRISE_NOTICE_CONFIRM';
// sprint_20230403 #14 START
export const ENTERPRISE_PRECANCEL = 'ENTERPRISE_PRECANCEL';
export const ENTERPRISE_PRECANCEL_CONFIRM = 'ENTERPRISE_PRECANCEL_CONFIRM';
// sprint_20230403 #14 END
// sprint_20230522_tma START
export const ENTERPRISE_REASON_FOR_CANCEL = 'ENTERPRISE_REASON_FOR_CANCEL';
// sprint_20230522_tma END

// Group
export const GROUP_DETAIL = 'GROUP_DETAIL';
export const GROUP_CONFIRM = 'GROUP_CONFIRM';
export const GROUP_REGISTER_EDIT = 'GROUP_REGISTER_EDIT';
export const GROUP_USER_ADMIN = 'GROUP_USER_ADMIN';
export const GROUP_USER_NOT_ADMIN = 'GROUP_USER_NOT_ADMIN';
export const SELECT_GROUP_DIALOG = 'SELECT_GROUP_DIALOG';
export const SELECT_GROUP_USER_HISTORY_DIALOG = 'SELECT_GROUP_USER_HISTORY_DIALOG';
export const SELECT_GROUP_MODAL = 'SELECT_GROUP_MODAL';

export const SELECT_GROUP_MODAL_PARTICIPANT = 'SELECT_GROUP_MODAL_PARTICIPANT';

export const REPORT_MODAL_DIALOG = 'REPORT_MODAL_DIALOG';
// Distribution Report Assignment
export const ASSIGNMENT_DISTRIBUTION_REPORT = 'ASSIGNMENT_DISTRIBUTION_REPORT';

export const SERVICE_USER_DIALOG = 'SERVICE_USER_DIALOG';

// Message Thread
export const ADD_USER_TO_MSG = 'ADD_USER_TO_MSG';
export const MSG_REGISTER_CONFIRM_DIALOG = 'MSG_REGISTER_CONFIRM_DIALOG';

export const SERVICE_NOTICE_CONFIRM_DIALOG = 'SERVICE_NOTICE_CONFIRM_DIALOG';
export const SERVICE_NOTICE_DETAIL = 'SERVICE_NOTICE_DETAIL';
export const ENTERPRISE_NOTICE_DETAIL = 'ENTERPRISE_NOTICE_DETAIL';

export const SELECT_USER_DIALOG = 'SELECT_USER_DIALOG';

export const LIVE_REGISTER_CONFIRM = 'LIVE_REGISTER_CONFIRM';

export const ATTRIBUTE_QUESTION_LIST = 'ATTRIBUTE_QUESTION_LIST';

// CSV
export const COURSE_BOX_DIALOG = 'COURSE_BOX_DIALOG';
export const SELECT_SERVICE_USER_DIALOG = 'SELECT_SERVICE_USER_DIALOG';
export const SELECT_COURSE_DIALOG = 'SELECT_COURSE_DIALOG';
export const SELECT_TARGET_CONTENT_DIALOG = 'SELECT_TARGET_CONTENT_DIALOG';
export const SELECT_TARGET_BOX_DIALOG = 'SELECT_TARGET_BOX_DIALOG';

// Email
export const EMAIL_REGISTER_EDIT_USER = 'EMAIL_REGISTER_EDIT_USER';
export const EMAIL_DETAIL_DIALOG = 'EMAIL_DETAIL_DIALOG';
export const RESERVED_EMAIL_CONFIRM_DIALOG = 'RESERVED_EMAIL_CONFIRM_DIALOG';

// Translation
//export const TRANSLATE_LANGUAGE = 'TRANSLATE_LANGUAGE';
export const TRANSLATE_CONFIRM = 'TRANSLATE_CONFIRM';
export const TRANSLATE_COMPLETE = 'TRANSLATE_COMPLETE';
export const TRANSLATE_EDIT = 'TRANSLATE_EDIT';
export const TRANSLATE_CONFIRM_DIALOG = 'TRANSLATE_CONFIRM_DIALOG';
// sprint_20230522 START
export const ITEM_TREE_CONTAINER = 'ITEM_TREE_CONTAINER';
// sprint_20230522 END

// Step 10.0.0 START 
export const SERVICE_GROUP_REGISTER_EDIT = 'SERVICE_GROUP_REGISTER_EDIT';
export const SERVICE_GROUP_DETAIL = 'SERVICE_GROUP_DETAIL';
export const SERVICE_GROUP_EDIT_SERVICE = 'SERVICE_GROUP_EDIT_SERVICE';
export const SERVICE_GROUP_EDIT_SUPERUSER = 'SERVICE_GROUP_EDIT_SUPERUSER';
export const SERVICE_GROUP_CONFIRM = 'SERVICE_GROUP_CONFIRM';
// Step 10.0.0 END